import styled from 'styled-components';
import { Grid } from '../../Grid';
import { mixins } from '../../../css';

export const StyledInternalGrid = styled(Grid.Container)`
  padding-top: ${mixins.pxToRem(50)};
`;
